import { BookSeriesTag } from "components/series/BookSeriesTag";
import TextLink from "hardcover-ui/components/TextLink";
import ContributionsList from "components/authors/ContributionsList";
import { EditionSerializersEdition, LetterbooksSerializersBook } from "types/serializers";

export default function CurrentlyReadingBookDetails({
  book,
  edition,
}: {
  book: LetterbooksSerializersBook;
  edition?: EditionSerializersEdition;
}) {
  const target = edition ? edition : book;

  return (
    <div className="w-full">
      <p className="shrink space-x-2 flex items-baseline justify-between w-full">
        <BookSeriesTag
          book={book}
          className="max-w-full sm:max-w-none overflow-hidden text-ellipsis"
        />
      </p>
      <div>
        <TextLink
          href={`/books/${book.slug}`}
          variant="title"
          size="xl"
          underline
        >
          {target.title}
        </TextLink>
        <ContributionsList
          contributions={book.contributions}
          link
          size="xs"
          primary
          byLine
        />
      </div>
    </div>
  );
}
